const pendingDemoVideoPosters = new WeakMap();
const demoVideoObserver = 'IntersectionObserver' in window
  ? new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          pendingDemoVideoPosters.get(entry.target)?.();
        });
      },
      { rootMargin: '500px 0px' },
    )
  : null;

const initializeDemoVideoPosters = (root = document) => {
  root.querySelectorAll('[data-product-demo-videos]').forEach((section) => {
    if (
      section.dataset.demoVideoPostersInitialized === 'true'
      || pendingDemoVideoPosters.has(section)
    ) return;

    const videos = [...section.querySelectorAll('video[data-poster]')];
    if (!videos.length) return;

    const loadPosters = () => {
      if (section.dataset.demoVideoPostersInitialized === 'true') return;

      demoVideoObserver?.unobserve(section);
      section.removeEventListener('pointerdown', loadPosters, true);
      section.removeEventListener('focusin', loadPosters, true);
      pendingDemoVideoPosters.delete(section);

      videos.forEach((video) => {
        video.poster = video.dataset.poster;
        delete video.dataset.poster;
      });
      section.dataset.demoVideoPostersInitialized = 'true';
    };

    if (!demoVideoObserver) {
      loadPosters();
      return;
    }

    pendingDemoVideoPosters.set(section, loadPosters);
    section.addEventListener('pointerdown', loadPosters, { once: true, capture: true });
    section.addEventListener('focusin', loadPosters, { once: true, capture: true });
    demoVideoObserver.observe(section);
  });
};

if (document.readyState === 'loading') {
  document.addEventListener(
    'DOMContentLoaded',
    () => initializeDemoVideoPosters(),
    { once: true },
  );
} else {
  initializeDemoVideoPosters();
}

document.addEventListener('shopify:section:load', (event) => initializeDemoVideoPosters(event.target));
